// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------Mixins------------------*/
.ml-0 {
  margin-left: 0px !important;
}

.mr-0 {
  margin-right: 0px !important;
}

.mt-0 {
  margin-top: 0px !important;
}

.mb-0 {
  margin-bottom: 0px !important;
}

.mx-0 {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.ml-1 {
  margin-left: 4px !important;
}

.mr-1 {
  margin-right: 4px !important;
}

.mt-1 {
  margin-top: 4px !important;
}

.mb-1 {
  margin-bottom: 4px !important;
}

.mx-1 {
  margin-left: 4px !important;
  margin-right: 4px !important;
}

.my-1 {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

.ml-2 {
  margin-left: 8px !important;
}

.mr-2 {
  margin-right: 8px !important;
}

.mt-2 {
  margin-top: 8px !important;
}

.mb-2 {
  margin-bottom: 8px !important;
}

.mx-2 {
  margin-left: 8px !important;
  margin-right: 8px !important;
}

.my-2 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}

.ml-3 {
  margin-left: 12px !important;
}

.mr-3 {
  margin-right: 12px !important;
}

.mt-3 {
  margin-top: 12px !important;
}

.mb-3 {
  margin-bottom: 12px !important;
}

.mx-3 {
  margin-left: 12px !important;
  margin-right: 12px !important;
}

.my-3 {
  margin-top: 12px !important;
  margin-bottom: 12px !important;
}

.ml-4 {
  margin-left: 16px !important;
}

.mr-4 {
  margin-right: 16px !important;
}

.mt-4 {
  margin-top: 16px !important;
}

.mb-4 {
  margin-bottom: 16px !important;
}

.mx-4 {
  margin-left: 16px !important;
  margin-right: 16px !important;
}

.my-4 {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}

.ml-5 {
  margin-left: 20px !important;
}

.mr-5 {
  margin-right: 20px !important;
}

.mt-5 {
  margin-top: 20px !important;
}

.mb-5 {
  margin-bottom: 20px !important;
}

.mx-5 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}

.my-5 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

.ml-6 {
  margin-left: 24px !important;
}

.mr-6 {
  margin-right: 24px !important;
}

.mt-6 {
  margin-top: 24px !important;
}

.mb-6 {
  margin-bottom: 24px !important;
}

.mx-6 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}

.my-6 {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}

.ml-7 {
  margin-left: 28px !important;
}

.mr-7 {
  margin-right: 28px !important;
}

.mt-7 {
  margin-top: 28px !important;
}

.mb-7 {
  margin-bottom: 28px !important;
}

.mx-7 {
  margin-left: 28px !important;
  margin-right: 28px !important;
}

.my-7 {
  margin-top: 28px !important;
  margin-bottom: 28px !important;
}

.ml-8 {
  margin-left: 32px !important;
}

.mr-8 {
  margin-right: 32px !important;
}

.mt-8 {
  margin-top: 32px !important;
}

.mb-8 {
  margin-bottom: 32px !important;
}

.mx-8 {
  margin-left: 32px !important;
  margin-right: 32px !important;
}

.my-8 {
  margin-top: 32px !important;
  margin-bottom: 32px !important;
}

.ml-9 {
  margin-left: 36px !important;
}

.mr-9 {
  margin-right: 36px !important;
}

.mt-9 {
  margin-top: 36px !important;
}

.mb-9 {
  margin-bottom: 36px !important;
}

.mx-9 {
  margin-left: 36px !important;
  margin-right: 36px !important;
}

.my-9 {
  margin-top: 36px !important;
  margin-bottom: 36px !important;
}

.ml-10 {
  margin-left: 40px !important;
}

.mr-10 {
  margin-right: 40px !important;
}

.mt-10 {
  margin-top: 40px !important;
}

.mb-10 {
  margin-bottom: 40px !important;
}

.mx-10 {
  margin-left: 40px !important;
  margin-right: 40px !important;
}

.my-10 {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}

.ml-11 {
  margin-left: 44px !important;
}

.mr-11 {
  margin-right: 44px !important;
}

.mt-11 {
  margin-top: 44px !important;
}

.mb-11 {
  margin-bottom: 44px !important;
}

.mx-11 {
  margin-left: 44px !important;
  margin-right: 44px !important;
}

.my-11 {
  margin-top: 44px !important;
  margin-bottom: 44px !important;
}

.ml-12 {
  margin-left: 48px !important;
}

.mr-12 {
  margin-right: 48px !important;
}

.mt-12 {
  margin-top: 48px !important;
}

.mb-12 {
  margin-bottom: 48px !important;
}

.mx-12 {
  margin-left: 48px !important;
  margin-right: 48px !important;
}

.my-12 {
  margin-top: 48px !important;
  margin-bottom: 48px !important;
}

.ml-13 {
  margin-left: 52px !important;
}

.mr-13 {
  margin-right: 52px !important;
}

.mt-13 {
  margin-top: 52px !important;
}

.mb-13 {
  margin-bottom: 52px !important;
}

.mx-13 {
  margin-left: 52px !important;
  margin-right: 52px !important;
}

.my-13 {
  margin-top: 52px !important;
  margin-bottom: 52px !important;
}

.ml-14 {
  margin-left: 56px !important;
}

.mr-14 {
  margin-right: 56px !important;
}

.mt-14 {
  margin-top: 56px !important;
}

.mb-14 {
  margin-bottom: 56px !important;
}

.mx-14 {
  margin-left: 56px !important;
  margin-right: 56px !important;
}

.my-14 {
  margin-top: 56px !important;
  margin-bottom: 56px !important;
}

.ml-15 {
  margin-left: 60px !important;
}

.mr-15 {
  margin-right: 60px !important;
}

.mt-15 {
  margin-top: 60px !important;
}

.mb-15 {
  margin-bottom: 60px !important;
}

.mx-15 {
  margin-left: 60px !important;
  margin-right: 60px !important;
}

.my-15 {
  margin-top: 60px !important;
  margin-bottom: 60px !important;
}

.ml-16 {
  margin-left: 64px !important;
}

.mr-16 {
  margin-right: 64px !important;
}

.mt-16 {
  margin-top: 64px !important;
}

.mb-16 {
  margin-bottom: 64px !important;
}

.mx-16 {
  margin-left: 64px !important;
  margin-right: 64px !important;
}

.my-16 {
  margin-top: 64px !important;
  margin-bottom: 64px !important;
}

.ml-17 {
  margin-left: 68px !important;
}

.mr-17 {
  margin-right: 68px !important;
}

.mt-17 {
  margin-top: 68px !important;
}

.mb-17 {
  margin-bottom: 68px !important;
}

.mx-17 {
  margin-left: 68px !important;
  margin-right: 68px !important;
}

.my-17 {
  margin-top: 68px !important;
  margin-bottom: 68px !important;
}

.ml-18 {
  margin-left: 72px !important;
}

.mr-18 {
  margin-right: 72px !important;
}

.mt-18 {
  margin-top: 72px !important;
}

.mb-18 {
  margin-bottom: 72px !important;
}

.mx-18 {
  margin-left: 72px !important;
  margin-right: 72px !important;
}

.my-18 {
  margin-top: 72px !important;
  margin-bottom: 72px !important;
}

.ml-19 {
  margin-left: 76px !important;
}

.mr-19 {
  margin-right: 76px !important;
}

.mt-19 {
  margin-top: 76px !important;
}

.mb-19 {
  margin-bottom: 76px !important;
}

.mx-19 {
  margin-left: 76px !important;
  margin-right: 76px !important;
}

.my-19 {
  margin-top: 76px !important;
  margin-bottom: 76px !important;
}

.pl-0 {
  padding-left: 0px !important;
}

.pr-0 {
  padding-right: 0px !important;
}

.pt-0 {
  padding-top: 0px !important;
}

.pb-0 {
  padding-bottom: 0px !important;
}

.px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.pl-1 {
  padding-left: 4px !important;
}

.pr-1 {
  padding-right: 4px !important;
}

.pt-1 {
  padding-top: 4px !important;
}

.pb-1 {
  padding-bottom: 4px !important;
}

.px-1 {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.py-1 {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.pl-2 {
  padding-left: 8px !important;
}

.pr-2 {
  padding-right: 8px !important;
}

.pt-2 {
  padding-top: 8px !important;
}

.pb-2 {
  padding-bottom: 8px !important;
}

.px-2 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.py-2 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.pl-3 {
  padding-left: 12px !important;
}

.pr-3 {
  padding-right: 12px !important;
}

.pt-3 {
  padding-top: 12px !important;
}

.pb-3 {
  padding-bottom: 12px !important;
}

.px-3 {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.py-3 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

.pl-4 {
  padding-left: 16px !important;
}

.pr-4 {
  padding-right: 16px !important;
}

.pt-4 {
  padding-top: 16px !important;
}

.pb-4 {
  padding-bottom: 16px !important;
}

.px-4 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.py-4 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}

.pl-5 {
  padding-left: 20px !important;
}

.pr-5 {
  padding-right: 20px !important;
}

.pt-5 {
  padding-top: 20px !important;
}

.pb-5 {
  padding-bottom: 20px !important;
}

.px-5 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.py-5 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.pl-6 {
  padding-left: 24px !important;
}

.pr-6 {
  padding-right: 24px !important;
}

.pt-6 {
  padding-top: 24px !important;
}

.pb-6 {
  padding-bottom: 24px !important;
}

.px-6 {
  padding-left: 24px !important;
  padding-right: 24px !important;
}

.py-6 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}

.pl-7 {
  padding-left: 28px !important;
}

.pr-7 {
  padding-right: 28px !important;
}

.pt-7 {
  padding-top: 28px !important;
}

.pb-7 {
  padding-bottom: 28px !important;
}

.px-7 {
  padding-left: 28px !important;
  padding-right: 28px !important;
}

.py-7 {
  padding-top: 28px !important;
  padding-bottom: 28px !important;
}

.pl-8 {
  padding-left: 32px !important;
}

.pr-8 {
  padding-right: 32px !important;
}

.pt-8 {
  padding-top: 32px !important;
}

.pb-8 {
  padding-bottom: 32px !important;
}

.px-8 {
  padding-left: 32px !important;
  padding-right: 32px !important;
}

.py-8 {
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}

.pl-9 {
  padding-left: 36px !important;
}

.pr-9 {
  padding-right: 36px !important;
}

.pt-9 {
  padding-top: 36px !important;
}

.pb-9 {
  padding-bottom: 36px !important;
}

.px-9 {
  padding-left: 36px !important;
  padding-right: 36px !important;
}

.py-9 {
  padding-top: 36px !important;
  padding-bottom: 36px !important;
}

.pl-10 {
  padding-left: 40px !important;
}

.pr-10 {
  padding-right: 40px !important;
}

.pt-10 {
  padding-top: 40px !important;
}

.pb-10 {
  padding-bottom: 40px !important;
}

.px-10 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}

.py-10 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}

.pl-11 {
  padding-left: 44px !important;
}

.pr-11 {
  padding-right: 44px !important;
}

.pt-11 {
  padding-top: 44px !important;
}

.pb-11 {
  padding-bottom: 44px !important;
}

.px-11 {
  padding-left: 44px !important;
  padding-right: 44px !important;
}

.py-11 {
  padding-top: 44px !important;
  padding-bottom: 44px !important;
}

.pl-12 {
  padding-left: 48px !important;
}

.pr-12 {
  padding-right: 48px !important;
}

.pt-12 {
  padding-top: 48px !important;
}

.pb-12 {
  padding-bottom: 48px !important;
}

.px-12 {
  padding-left: 48px !important;
  padding-right: 48px !important;
}

.py-12 {
  padding-top: 48px !important;
  padding-bottom: 48px !important;
}

.pl-13 {
  padding-left: 52px !important;
}

.pr-13 {
  padding-right: 52px !important;
}

.pt-13 {
  padding-top: 52px !important;
}

.pb-13 {
  padding-bottom: 52px !important;
}

.px-13 {
  padding-left: 52px !important;
  padding-right: 52px !important;
}

.py-13 {
  padding-top: 52px !important;
  padding-bottom: 52px !important;
}

.pl-14 {
  padding-left: 56px !important;
}

.pr-14 {
  padding-right: 56px !important;
}

.pt-14 {
  padding-top: 56px !important;
}

.pb-14 {
  padding-bottom: 56px !important;
}

.px-14 {
  padding-left: 56px !important;
  padding-right: 56px !important;
}

.py-14 {
  padding-top: 56px !important;
  padding-bottom: 56px !important;
}

.pl-15 {
  padding-left: 60px !important;
}

.pr-15 {
  padding-right: 60px !important;
}

.pt-15 {
  padding-top: 60px !important;
}

.pb-15 {
  padding-bottom: 60px !important;
}

.px-15 {
  padding-left: 60px !important;
  padding-right: 60px !important;
}

.py-15 {
  padding-top: 60px !important;
  padding-bottom: 60px !important;
}

.pl-16 {
  padding-left: 64px !important;
}

.pr-16 {
  padding-right: 64px !important;
}

.pt-16 {
  padding-top: 64px !important;
}

.pb-16 {
  padding-bottom: 64px !important;
}

.px-16 {
  padding-left: 64px !important;
  padding-right: 64px !important;
}

.py-16 {
  padding-top: 64px !important;
  padding-bottom: 64px !important;
}

.pl-17 {
  padding-left: 68px !important;
}

.pr-17 {
  padding-right: 68px !important;
}

.pt-17 {
  padding-top: 68px !important;
}

.pb-17 {
  padding-bottom: 68px !important;
}

.px-17 {
  padding-left: 68px !important;
  padding-right: 68px !important;
}

.py-17 {
  padding-top: 68px !important;
  padding-bottom: 68px !important;
}

.pl-18 {
  padding-left: 72px !important;
}

.pr-18 {
  padding-right: 72px !important;
}

.pt-18 {
  padding-top: 72px !important;
}

.pb-18 {
  padding-bottom: 72px !important;
}

.px-18 {
  padding-left: 72px !important;
  padding-right: 72px !important;
}

.py-18 {
  padding-top: 72px !important;
  padding-bottom: 72px !important;
}

.pl-19 {
  padding-left: 76px !important;
}

.pr-19 {
  padding-right: 76px !important;
}

.pt-19 {
  padding-top: 76px !important;
}

.pb-19 {
  padding-bottom: 76px !important;
}

.px-19 {
  padding-left: 76px !important;
  padding-right: 76px !important;
}

.py-19 {
  padding-top: 76px !important;
  padding-bottom: 76px !important;
}

.productPages-layout {
  padding-top: 156px;
}
@media (max-width: 899px) {
  .productPages-layout {
    padding-top: 85px;
  }
}
.productPages-layout .pp-inner {
  padding-top: 80px;
}
@media (max-width: 899px) {
  .productPages-layout .pp-inner {
    padding-top: 30px;
  }
  .productPages-layout .pp-inner h1 {
    font-size: 2rem;
    line-height: 45px;
  }
  .productPages-layout .pp-inner h2 {
    font-size: 1.5rem;
    line-height: 36px;
  }
}
.productPages-layout .pp-inner h3 {
  font-size: 1.5rem;
  line-height: 36px;
}
@media (max-width: 899px) {
  .productPages-layout .pp-inner h3 {
    font-size: 1.5rem;
    line-height: 36px;
  }
  .productPages-layout .pp-inner h4 {
    font-size: 1.25rem;
    line-height: 30px;
  }
}
.productPages-layout .pp-inner p {
  color: rgb(37, 37, 37);
}
@media (max-width: 899px) {
  .productPages-layout .pp-inner .mb-margin1 {
    margin-bottom: 40px !important;
  }
  .productPages-layout .pp-inner .mb-margin2 {
    margin-bottom: 24px !important;
  }
}
.productPages-layout .pp-inner .ordered-list {
  padding-left: 15px;
}
.productPages-layout .pp-inner .ordered-list li {
  margin-bottom: 12px;
  position: relative;
  font-size: 0.875rem;
  line-height: 25px;
  color: rgb(34, 34, 34);
  text-align: justify;
  list-style-type: decimal;
}
@media (max-width: 899px) {
  .productPages-layout .pp-inner .ordered-list li {
    font-size: 0.75rem;
    line-height: 18px;
  }
}
.productPages-layout .pp-inner .ordered-list li:last-child {
  margin-bottom: 0;
}
.productPages-layout .pp-inner .ordered-list li span {
  font-weight: 500;
}
.productPages-layout .pp-inner .main_pp ul li {
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 8px;
  color: rgb(89, 89, 89);
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .main_pp ul li {
    text-align: justify;
  }
}
.productPages-layout .pp-inner .main_pp ul li span {
  color: rgb(34, 34, 34);
  font-weight: 600;
}
.productPages-layout .pp-inner .main_pp ul li:last-child {
  margin-bottom: 0;
}
.productPages-layout .pp-inner .main_pp .whyChoose_pp_section h2 {
  margin-bottom: 56px;
}
@media (max-width: 899px) {
  .productPages-layout .pp-inner .main_pp .whyChoose_pp_section h2 {
    text-align: center;
    margin-bottom: 24px;
  }
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .main_pp .whyChoose_pp_section .wchoose_img {
    max-width: 280px !important;
  }
}
.productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: center;
  flex-direction: row-reverse;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list {
    gap: 12px;
  }
}
.productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list li {
  width: calc(50% - 12px);
  display: flex;
  flex-direction: column;
  gap: 24px;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list li {
    gap: 12px;
    width: calc(50% - 6px);
  }
}
.productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box {
  box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.12);
  border-radius: 12px;
  padding: 24px;
  text-align: center;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box {
    padding: 12px;
  }
}
.productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box img {
  margin: auto;
  width: 90px;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box img {
    width: 60px;
  }
}
.productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box h6 {
  margin-top: 24px;
  margin-bottom: 12px;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box h6 {
    margin-top: 12px;
    font-size: 14px;
    line-height: 21px;
  }
}
.productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box p {
  color: rgb(89, 89, 89);
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box p {
    font-size: 12px;
    line-height: 18px;
  }
}
.productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list2 {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: center;
  justify-content: center;
  flex-direction: row-reverse;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list2 {
    gap: 12px;
  }
}
.productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list2 li {
  width: calc(50% - 12px);
  display: flex;
  flex-direction: column;
  gap: 24px;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list2 li {
    gap: 12px;
    width: calc(50% - 6px);
  }
}
.productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box {
  box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.12);
  border-radius: 12px;
  padding: 24px;
  text-align: center;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box {
    padding: 12px;
  }
}
.productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box img {
  margin: auto;
  width: 90px;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box img {
    width: 60px;
  }
}
.productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box h6 {
  margin-top: 24px;
  margin-bottom: 12px;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box h6 {
    margin-top: 12px;
    font-size: 14px;
    line-height: 21px;
  }
}
.productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box p {
  color: rgb(89, 89, 89);
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .main_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box p {
    font-size: 12px;
    line-height: 18px;
  }
}
.productPages-layout .pp-inner .main_pp .formBox {
  border-radius: 12px;
  padding: 20px 8px;
  background: #E9F1FD;
}
.productPages-layout .pp-inner .main_pp .formBox .checkbox .MuiTypography-root {
  font-size: 12px !important;
  text-align: justify;
}
.productPages-layout .pp-inner .subProducts_pp {
  margin-bottom: 80px;
}
@media (max-width: 899px) {
  .productPages-layout .pp-inner .subProducts_pp {
    margin-bottom: 40px !important;
  }
}
.productPages-layout .pp-inner .subProducts_pp .points-slider {
  margin-bottom: 12px;
}
.productPages-layout .pp-inner .subProducts_pp .points-slider .pointBox {
  box-shadow: 0 4px 14px 0 rgba(30, 46, 95, 0.06);
  border-radius: 50px 0 20px 20px;
  padding: 24px;
  position: relative;
  min-height: 252px;
  margin-bottom: 12px;
  text-align: left;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .points-slider .pointBox {
    min-height: 200px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .points-slider .pointBox:before {
  content: "";
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 50px 0 0 0;
  border-top: 1px solid #1E2E5F;
  border-left: 1px solid #1E2E5F;
  left: 0;
  top: 0;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .points-slider .pointBox h4 {
    font-size: 20px;
    line-height: 30px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .points-slider .pointBox p {
  font-size: 16px;
  line-height: 24px;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .points-slider .pointBox p {
    font-size: 14px;
    line-height: 21px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .slick-slider .slick-active button {
  min-width: 32px;
  outline: 1px solid #1E2E5F;
  outline-offset: -1px;
  background: transparent;
}
.productPages-layout .pp-inner .subProducts_pp .slick-slider .slick-dots li {
  margin: 0px 4px;
  width: 12px;
  height: 12px;
}
.productPages-layout .pp-inner .subProducts_pp .slick-slider .slick-dots li.slick-active {
  min-width: 32px;
  width: 32px;
}
.productPages-layout .pp-inner .subProducts_pp .slick-slider li button {
  background: rgba(36, 72, 140, 0.4);
  border-radius: 50px !important;
  border: none;
  width: 12px;
  height: 12px;
}
.productPages-layout .pp-inner .subProducts_pp .slick-slider li button::before {
  display: none;
}
.productPages-layout .pp-inner .subProducts_pp .coverages-section {
  margin-bottom: 80px;
}
@media (max-width: 899px) {
  .productPages-layout .pp-inner .subProducts_pp .coverages-section h2 {
    text-align: center;
  }
}
.productPages-layout .pp-inner .subProducts_pp .claimProcedure-section {
  margin-bottom: 80px;
}
.productPages-layout .pp-inner .subProducts_pp .claimProcedure-section .claimProcedure_list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
@media (max-width: 699px) {
  .productPages-layout .pp-inner .subProducts_pp .claimProcedure-section .claimProcedure_list {
    gap: 16px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .claimProcedure-section .claimProcedure_list li {
  flex: 1 1;
  border-radius: 12px;
  padding: 24px;
  box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.12);
}
.productPages-layout .pp-inner .subProducts_pp .claimProcedure-section .claimProcedure_list li:nth-child(odd):last-child {
  width: 100%;
}
@media (max-width: 699px) {
  .productPages-layout .pp-inner .subProducts_pp .claimProcedure-section .claimProcedure_list li {
    width: 100%;
  }
}
@media (max-width: 499px) {
  .productPages-layout .pp-inner .subProducts_pp .claimProcedure-section .claimProcedure_list li {
    padding: 16px;
    min-width: 240px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .claimProcedure-section .claimProcedure_list li h4 {
  font-size: 20px;
  margin-bottom: 12px;
  color: #1E2E5F;
}
.productPages-layout .pp-inner .subProducts_pp .claimProcedure-section .claimProcedure_list li h6 {
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 12px;
}
.productPages-layout .pp-inner .subProducts_pp .claimProcedure-section .claimProcedure_list li p {
  color: rgb(89, 89, 89);
}
.productPages-layout .pp-inner .subProducts_pp .claimProcedure-section .claimProcedure_list li p a {
  font-weight: 600;
  color: #1E2E5F;
}
.productPages-layout .pp-inner .subProducts_pp .alopTop-section {
  margin-bottom: 80px;
}
.productPages-layout .pp-inner .subProducts_pp .alopTop-section .alop_list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
@media (max-width: 699px) {
  .productPages-layout .pp-inner .subProducts_pp .alopTop-section .alop_list {
    gap: 16px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .alopTop-section .alop_list li {
  flex: 1 1;
  border-radius: 12px;
  padding: 24px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(91, 132, 188, 0.05) 100%);
}
.productPages-layout .pp-inner .subProducts_pp .alopTop-section .alop_list li:nth-child(odd):last-child {
  width: 100%;
}
@media (max-width: 699px) {
  .productPages-layout .pp-inner .subProducts_pp .alopTop-section .alop_list li {
    width: 100%;
  }
}
@media (max-width: 499px) {
  .productPages-layout .pp-inner .subProducts_pp .alopTop-section .alop_list li {
    padding: 16px;
    min-width: 240px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .alopTop-section .alop_list li h4 {
  font-size: 20px;
  margin-bottom: 12px;
}
.productPages-layout .pp-inner .subProducts_pp .alopTop-section .alop_list li h6 {
  font-weight: 600;
  margin-bottom: 20px;
  color: #1E2E5F;
}
.productPages-layout .pp-inner .subProducts_pp .alopTop-section .alop_list li p {
  color: rgb(89, 89, 89);
}
.productPages-layout .pp-inner .subProducts_pp .alopTop-section .alop_list li p a {
  font-weight: 600;
  color: #1E2E5F;
}
.productPages-layout .pp-inner .subProducts_pp .termsConditions_section,
.productPages-layout .pp-inner .subProducts_pp .excluison_section {
  margin-bottom: 80px;
}
@media (max-width: 899px) {
  .productPages-layout .pp-inner .subProducts_pp .termsConditions_section h2,
  .productPages-layout .pp-inner .subProducts_pp .excluison_section h2 {
    text-align: center;
  }
}
.productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section h2 {
  margin-bottom: 56px;
}
@media (max-width: 899px) {
  .productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section h2 {
    text-align: center;
    margin-bottom: 24px;
  }
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .wchoose_img {
    max-width: 280px !important;
  }
}
.productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: center;
  flex-direction: row-reverse;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list {
    gap: 12px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list li {
  width: calc(50% - 12px);
  display: flex;
  flex-direction: column;
  gap: 24px;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list li {
    gap: 12px;
    width: calc(50% - 6px);
  }
}
.productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box {
  box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.12);
  border-radius: 12px;
  padding: 24px;
  text-align: center;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box {
    padding: 12px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box img {
  margin: auto;
  width: 90px;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box img {
    width: 60px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box h6 {
  margin-top: 24px;
  margin-bottom: 12px;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box h6 {
    margin-top: 12px;
    font-size: 14px;
    line-height: 21px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box p {
  color: rgb(89, 89, 89);
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list li .wc_box p {
    font-size: 12px;
    line-height: 18px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list2 {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: center;
  justify-content: center;
  flex-direction: row-reverse;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list2 {
    gap: 12px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list2 li {
  width: calc(50% - 12px);
  display: flex;
  flex-direction: column;
  gap: 24px;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list2 li {
    gap: 12px;
    width: calc(50% - 6px);
  }
}
.productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box {
  box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.12);
  border-radius: 12px;
  padding: 24px;
  text-align: center;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box {
    padding: 12px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box img {
  margin: auto;
  width: 90px;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box img {
    width: 60px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box h6 {
  margin-top: 24px;
  margin-bottom: 12px;
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box h6 {
    margin-top: 12px;
    font-size: 14px;
    line-height: 21px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box p {
  color: rgb(89, 89, 89);
}
@media (max-width: 599px) {
  .productPages-layout .pp-inner .subProducts_pp .whyChoose_pp_section .whyChoosepp_list2 li .wc_box p {
    font-size: 12px;
    line-height: 18px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .errors-ommission-section {
  margin-bottom: 80px;
}
.productPages-layout .pp-inner .subProducts_pp .errors-ommission-section .omissionPointList {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
@media (max-width: 699px) {
  .productPages-layout .pp-inner .subProducts_pp .errors-ommission-section .omissionPointList {
    gap: 16px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .errors-ommission-section .omissionPointList li {
  width: calc(33.3333333333% - 16px);
  border-radius: 24px;
  padding: 24px;
  background: rgba(30, 113, 236, 0.1019607843);
}
@media (max-width: 699px) {
  .productPages-layout .pp-inner .subProducts_pp .errors-ommission-section .omissionPointList li {
    width: 100%;
  }
}
@media (max-width: 499px) {
  .productPages-layout .pp-inner .subProducts_pp .errors-ommission-section .omissionPointList li {
    padding: 16px;
    min-width: 240px;
  }
}
.productPages-layout .pp-inner .subProducts_pp .errors-ommission-section .omissionPointList li h4 {
  font-size: 20px;
  margin-bottom: 12px;
  color: #000000;
}
.productPages-layout .pp-inner .subProducts_pp .errors-ommission-section .omissionPointList li h6 {
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 12px;
}
.productPages-layout .pp-inner .subProducts_pp .errors-ommission-section .omissionPointList li p {
  color: rgb(89, 89, 89);
}
.productPages-layout .pp-inner .subProducts_pp .errors-ommission-section .omissionPointList li p a {
  font-weight: 600;
  color: #1E2E5F;
}
.productPages-layout .pp-inner .scroll-box-section .scrollBox {
  overflow-y: scroll;
}
.productPages-layout .pp-inner .scroll-box-section .scrollBox .scrollBox-inner {
  max-height: 200px;
}
.productPages-layout .pp-inner .scroll-box-section .scrollBox .scrollBox-inner ul li {
  margin-bottom: 12px;
}
.productPages-layout .pp-inner .scroll-box-section .scrollBox .scrollBox-inner ul li:last-child {
  margin-bottom: 0;
}
.productPages-layout .pp-inner .scroll-box-section .scrollBox .scrollBox-inner ul li .dottted-list {
  padding-left: 30px;
  margin-top: 12px;
}
.productPages-layout .pp-inner .scroll-box-section .scrollBox .scrollBox-inner ul li .dottted-list li {
  list-style-type: disc;
  font-size: 13px;
}
.productPages-layout .pp-inner .exclusion_list {
  overflow-y: scroll;
}
.productPages-layout .pp-inner .exclusion_list .ordered-list {
  max-height: 200px;
}
.productPages-layout .pp-inner .exclusion_list .ordered-list .exclusion_list {
  overflow-y: scroll;
}
.productPages-layout .pp-inner .exclusion_list .ordered-list .exclusion_list .ordered-list {
  max-height: 200px;
}
.productPages-layout .pp-inner .exclusion_list .ordered-list .ordered-inner-list li {
  list-style: none;
}
.productPages-layout .pp-inner .animatedbtn button svg {
  animation: arrowmove 1s infinite linear;
  margin-left: 4px;
  width: 20px;
}
.productPages-layout .pp-inner .animatedbtn button svg path {
  fill: #fff;
}
@keyframes arrowmove {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(4px);
  }
  100% {
    transform: translateX(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/SCSS/Mixins.scss","webpack://./src/SCSS/ProductPages.scss"],"names":[],"mappings":"AAWA,yCAAA;AAoDI;EACI,2BAAA;AC7DR;;ADgEI;EACI,4BAAA;AC7DR;;ADgEI;EACI,0BAAA;AC7DR;;ADgEI;EACI,6BAAA;AC7DR;;ADgEI;EACI,2BAAA;EACA,4BAAA;AC7DR;;ADgEI;EACI,0BAAA;EACA,6BAAA;AC7DR;;ADsCI;EACI,2BAAA;ACnCR;;ADsCI;EACI,4BAAA;ACnCR;;ADsCI;EACI,0BAAA;ACnCR;;ADsCI;EACI,6BAAA;ACnCR;;ADsCI;EACI,2BAAA;EACA,4BAAA;ACnCR;;ADsCI;EACI,0BAAA;EACA,6BAAA;ACnCR;;ADYI;EACI,2BAAA;ACTR;;ADYI;EACI,4BAAA;ACTR;;ADYI;EACI,0BAAA;ACTR;;ADYI;EACI,6BAAA;ACTR;;ADYI;EACI,2BAAA;EACA,4BAAA;ACTR;;ADYI;EACI,0BAAA;EACA,6BAAA;ACTR;;ADdI;EACI,4BAAA;ACiBR;;ADdI;EACI,6BAAA;ACiBR;;ADdI;EACI,2BAAA;ACiBR;;ADdI;EACI,8BAAA;ACiBR;;ADdI;EACI,4BAAA;EACA,6BAAA;ACiBR;;ADdI;EACI,2BAAA;EACA,8BAAA;ACiBR;;ADxCI;EACI,4BAAA;AC2CR;;ADxCI;EACI,6BAAA;AC2CR;;ADxCI;EACI,2BAAA;AC2CR;;ADxCI;EACI,8BAAA;AC2CR;;ADxCI;EACI,4BAAA;EACA,6BAAA;AC2CR;;ADxCI;EACI,2BAAA;EACA,8BAAA;AC2CR;;ADlEI;EACI,4BAAA;ACqER;;ADlEI;EACI,6BAAA;ACqER;;ADlEI;EACI,2BAAA;ACqER;;ADlEI;EACI,8BAAA;ACqER;;ADlEI;EACI,4BAAA;EACA,6BAAA;ACqER;;ADlEI;EACI,2BAAA;EACA,8BAAA;ACqER;;AD5FI;EACI,4BAAA;AC+FR;;AD5FI;EACI,6BAAA;AC+FR;;AD5FI;EACI,2BAAA;AC+FR;;AD5FI;EACI,8BAAA;AC+FR;;AD5FI;EACI,4BAAA;EACA,6BAAA;AC+FR;;AD5FI;EACI,2BAAA;EACA,8BAAA;AC+FR;;ADtHI;EACI,4BAAA;ACyHR;;ADtHI;EACI,6BAAA;ACyHR;;ADtHI;EACI,2BAAA;ACyHR;;ADtHI;EACI,8BAAA;ACyHR;;ADtHI;EACI,4BAAA;EACA,6BAAA;ACyHR;;ADtHI;EACI,2BAAA;EACA,8BAAA;ACyHR;;ADhJI;EACI,4BAAA;ACmJR;;ADhJI;EACI,6BAAA;ACmJR;;ADhJI;EACI,2BAAA;ACmJR;;ADhJI;EACI,8BAAA;ACmJR;;ADhJI;EACI,4BAAA;EACA,6BAAA;ACmJR;;ADhJI;EACI,2BAAA;EACA,8BAAA;ACmJR;;AD1KI;EACI,4BAAA;AC6KR;;AD1KI;EACI,6BAAA;AC6KR;;AD1KI;EACI,2BAAA;AC6KR;;AD1KI;EACI,8BAAA;AC6KR;;AD1KI;EACI,4BAAA;EACA,6BAAA;AC6KR;;AD1KI;EACI,2BAAA;EACA,8BAAA;AC6KR;;ADpMI;EACI,4BAAA;ACuMR;;ADpMI;EACI,6BAAA;ACuMR;;ADpMI;EACI,2BAAA;ACuMR;;ADpMI;EACI,8BAAA;ACuMR;;ADpMI;EACI,4BAAA;EACA,6BAAA;ACuMR;;ADpMI;EACI,2BAAA;EACA,8BAAA;ACuMR;;AD9NI;EACI,4BAAA;ACiOR;;AD9NI;EACI,6BAAA;ACiOR;;AD9NI;EACI,2BAAA;ACiOR;;AD9NI;EACI,8BAAA;ACiOR;;AD9NI;EACI,4BAAA;EACA,6BAAA;ACiOR;;AD9NI;EACI,2BAAA;EACA,8BAAA;ACiOR;;ADxPI;EACI,4BAAA;AC2PR;;ADxPI;EACI,6BAAA;AC2PR;;ADxPI;EACI,2BAAA;AC2PR;;ADxPI;EACI,8BAAA;AC2PR;;ADxPI;EACI,4BAAA;EACA,6BAAA;AC2PR;;ADxPI;EACI,2BAAA;EACA,8BAAA;AC2PR;;ADlRI;EACI,4BAAA;ACqRR;;ADlRI;EACI,6BAAA;ACqRR;;ADlRI;EACI,2BAAA;ACqRR;;ADlRI;EACI,8BAAA;ACqRR;;ADlRI;EACI,4BAAA;EACA,6BAAA;ACqRR;;ADlRI;EACI,2BAAA;EACA,8BAAA;ACqRR;;AD5SI;EACI,4BAAA;AC+SR;;AD5SI;EACI,6BAAA;AC+SR;;AD5SI;EACI,2BAAA;AC+SR;;AD5SI;EACI,8BAAA;AC+SR;;AD5SI;EACI,4BAAA;EACA,6BAAA;AC+SR;;AD5SI;EACI,2BAAA;EACA,8BAAA;AC+SR;;ADtUI;EACI,4BAAA;ACyUR;;ADtUI;EACI,6BAAA;ACyUR;;ADtUI;EACI,2BAAA;ACyUR;;ADtUI;EACI,8BAAA;ACyUR;;ADtUI;EACI,4BAAA;EACA,6BAAA;ACyUR;;ADtUI;EACI,2BAAA;EACA,8BAAA;ACyUR;;ADhWI;EACI,4BAAA;ACmWR;;ADhWI;EACI,6BAAA;ACmWR;;ADhWI;EACI,2BAAA;ACmWR;;ADhWI;EACI,8BAAA;ACmWR;;ADhWI;EACI,4BAAA;EACA,6BAAA;ACmWR;;ADhWI;EACI,2BAAA;EACA,8BAAA;ACmWR;;AD1XI;EACI,4BAAA;AC6XR;;AD1XI;EACI,6BAAA;AC6XR;;AD1XI;EACI,2BAAA;AC6XR;;AD1XI;EACI,8BAAA;AC6XR;;AD1XI;EACI,4BAAA;EACA,6BAAA;AC6XR;;AD1XI;EACI,2BAAA;EACA,8BAAA;AC6XR;;ADpZI;EACI,4BAAA;ACuZR;;ADpZI;EACI,6BAAA;ACuZR;;ADpZI;EACI,2BAAA;ACuZR;;ADpZI;EACI,8BAAA;ACuZR;;ADpZI;EACI,4BAAA;EACA,6BAAA;ACuZR;;ADpZI;EACI,2BAAA;EACA,8BAAA;ACuZR;;AD9aI;EACI,4BAAA;ACibR;;AD9aI;EACI,6BAAA;ACibR;;AD9aI;EACI,2BAAA;ACibR;;AD9aI;EACI,8BAAA;ACibR;;AD9aI;EACI,4BAAA;EACA,6BAAA;ACibR;;AD9aI;EACI,2BAAA;EACA,8BAAA;ACibR;;AD3aI;EACI,4BAAA;AC8aR;;AD3aI;EACI,6BAAA;AC8aR;;AD3aI;EACI,2BAAA;AC8aR;;AD3aI;EACI,8BAAA;AC8aR;;AD3aI;EACI,4BAAA;EACA,6BAAA;AC8aR;;AD3aI;EACI,2BAAA;EACA,8BAAA;AC8aR;;ADrcI;EACI,4BAAA;ACwcR;;ADrcI;EACI,6BAAA;ACwcR;;ADrcI;EACI,2BAAA;ACwcR;;ADrcI;EACI,8BAAA;ACwcR;;ADrcI;EACI,4BAAA;EACA,6BAAA;ACwcR;;ADrcI;EACI,2BAAA;EACA,8BAAA;ACwcR;;AD/dI;EACI,4BAAA;ACkeR;;AD/dI;EACI,6BAAA;ACkeR;;AD/dI;EACI,2BAAA;ACkeR;;AD/dI;EACI,8BAAA;ACkeR;;AD/dI;EACI,4BAAA;EACA,6BAAA;ACkeR;;AD/dI;EACI,2BAAA;EACA,8BAAA;ACkeR;;ADzfI;EACI,6BAAA;AC4fR;;ADzfI;EACI,8BAAA;AC4fR;;ADzfI;EACI,4BAAA;AC4fR;;ADzfI;EACI,+BAAA;AC4fR;;ADzfI;EACI,6BAAA;EACA,8BAAA;AC4fR;;ADzfI;EACI,4BAAA;EACA,+BAAA;AC4fR;;ADnhBI;EACI,6BAAA;ACshBR;;ADnhBI;EACI,8BAAA;ACshBR;;ADnhBI;EACI,4BAAA;ACshBR;;ADnhBI;EACI,+BAAA;ACshBR;;ADnhBI;EACI,6BAAA;EACA,8BAAA;ACshBR;;ADnhBI;EACI,4BAAA;EACA,+BAAA;ACshBR;;AD7iBI;EACI,6BAAA;ACgjBR;;AD7iBI;EACI,8BAAA;ACgjBR;;AD7iBI;EACI,4BAAA;ACgjBR;;AD7iBI;EACI,+BAAA;ACgjBR;;AD7iBI;EACI,6BAAA;EACA,8BAAA;ACgjBR;;AD7iBI;EACI,4BAAA;EACA,+BAAA;ACgjBR;;ADvkBI;EACI,6BAAA;AC0kBR;;ADvkBI;EACI,8BAAA;AC0kBR;;ADvkBI;EACI,4BAAA;AC0kBR;;ADvkBI;EACI,+BAAA;AC0kBR;;ADvkBI;EACI,6BAAA;EACA,8BAAA;AC0kBR;;ADvkBI;EACI,4BAAA;EACA,+BAAA;AC0kBR;;ADjmBI;EACI,6BAAA;AComBR;;ADjmBI;EACI,8BAAA;AComBR;;ADjmBI;EACI,4BAAA;AComBR;;ADjmBI;EACI,+BAAA;AComBR;;ADjmBI;EACI,6BAAA;EACA,8BAAA;AComBR;;ADjmBI;EACI,4BAAA;EACA,+BAAA;AComBR;;AD3nBI;EACI,6BAAA;AC8nBR;;AD3nBI;EACI,8BAAA;AC8nBR;;AD3nBI;EACI,4BAAA;AC8nBR;;AD3nBI;EACI,+BAAA;AC8nBR;;AD3nBI;EACI,6BAAA;EACA,8BAAA;AC8nBR;;AD3nBI;EACI,4BAAA;EACA,+BAAA;AC8nBR;;ADrpBI;EACI,6BAAA;ACwpBR;;ADrpBI;EACI,8BAAA;ACwpBR;;ADrpBI;EACI,4BAAA;ACwpBR;;ADrpBI;EACI,+BAAA;ACwpBR;;ADrpBI;EACI,6BAAA;EACA,8BAAA;ACwpBR;;ADrpBI;EACI,4BAAA;EACA,+BAAA;ACwpBR;;AD/qBI;EACI,6BAAA;ACkrBR;;AD/qBI;EACI,8BAAA;ACkrBR;;AD/qBI;EACI,4BAAA;ACkrBR;;AD/qBI;EACI,+BAAA;ACkrBR;;AD/qBI;EACI,6BAAA;EACA,8BAAA;ACkrBR;;AD/qBI;EACI,4BAAA;EACA,+BAAA;ACkrBR;;ADzsBI;EACI,6BAAA;AC4sBR;;ADzsBI;EACI,8BAAA;AC4sBR;;ADzsBI;EACI,4BAAA;AC4sBR;;ADzsBI;EACI,+BAAA;AC4sBR;;ADzsBI;EACI,6BAAA;EACA,8BAAA;AC4sBR;;ADzsBI;EACI,4BAAA;EACA,+BAAA;AC4sBR;;ADnuBI;EACI,6BAAA;ACsuBR;;ADnuBI;EACI,8BAAA;ACsuBR;;ADnuBI;EACI,4BAAA;ACsuBR;;ADnuBI;EACI,+BAAA;ACsuBR;;ADnuBI;EACI,6BAAA;EACA,8BAAA;ACsuBR;;ADnuBI;EACI,4BAAA;EACA,+BAAA;ACsuBR;;AD7vBI;EACI,6BAAA;ACgwBR;;AD7vBI;EACI,8BAAA;ACgwBR;;AD7vBI;EACI,4BAAA;ACgwBR;;AD7vBI;EACI,+BAAA;ACgwBR;;AD7vBI;EACI,6BAAA;EACA,8BAAA;ACgwBR;;AD7vBI;EACI,4BAAA;EACA,+BAAA;ACgwBR;;ADvxBI;EACI,6BAAA;AC0xBR;;ADvxBI;EACI,8BAAA;AC0xBR;;ADvxBI;EACI,4BAAA;AC0xBR;;ADvxBI;EACI,+BAAA;AC0xBR;;ADvxBI;EACI,6BAAA;EACA,8BAAA;AC0xBR;;ADvxBI;EACI,4BAAA;EACA,+BAAA;AC0xBR;;ADjzBI;EACI,6BAAA;ACozBR;;ADjzBI;EACI,8BAAA;ACozBR;;ADjzBI;EACI,4BAAA;ACozBR;;ADjzBI;EACI,+BAAA;ACozBR;;ADjzBI;EACI,6BAAA;EACA,8BAAA;ACozBR;;ADjzBI;EACI,4BAAA;EACA,+BAAA;ACozBR;;AD30BI;EACI,6BAAA;AC80BR;;AD30BI;EACI,8BAAA;AC80BR;;AD30BI;EACI,4BAAA;AC80BR;;AD30BI;EACI,+BAAA;AC80BR;;AD30BI;EACI,6BAAA;EACA,8BAAA;AC80BR;;AD30BI;EACI,4BAAA;EACA,+BAAA;AC80BR;;ADr2BI;EACI,6BAAA;ACw2BR;;ADr2BI;EACI,8BAAA;ACw2BR;;ADr2BI;EACI,4BAAA;ACw2BR;;ADr2BI;EACI,+BAAA;ACw2BR;;ADr2BI;EACI,6BAAA;EACA,8BAAA;ACw2BR;;ADr2BI;EACI,4BAAA;EACA,+BAAA;ACw2BR;;AD/3BI;EACI,6BAAA;ACk4BR;;AD/3BI;EACI,8BAAA;ACk4BR;;AD/3BI;EACI,4BAAA;ACk4BR;;AD/3BI;EACI,+BAAA;ACk4BR;;AD/3BI;EACI,6BAAA;EACA,8BAAA;ACk4BR;;AD/3BI;EACI,4BAAA;EACA,+BAAA;ACk4BR;;ADz5BI;EACI,6BAAA;AC45BR;;ADz5BI;EACI,8BAAA;AC45BR;;ADz5BI;EACI,4BAAA;AC45BR;;ADz5BI;EACI,+BAAA;AC45BR;;ADz5BI;EACI,6BAAA;EACA,8BAAA;AC45BR;;ADz5BI;EACI,4BAAA;EACA,+BAAA;AC45BR;;AA7gCA;EACI,kBAAA;AAghCJ;AA9gCI;EAHJ;IAIQ,iBAAA;EAihCN;AACF;AA/gCI;EACI,iBAAA;AAihCR;AA/gCQ;EAHJ;IAIQ,iBAAA;EAkhCV;EA/gCM;IDqBJ,eAAA;IClBY,iBAAA;EAkhCd;EA9gCM;IDcJ,iBAAA;ICXY,iBAAA;EAihCd;AAXF;AAlgCQ;EDOJ,iBAAA;ECLQ,iBAAA;AAghCZ;AA9gCY;EAJJ;IDOJ,iBAAA;ICDY,iBAAA;EAihCd;EA7gCM;IDHJ,kBAAA;ICMY,iBAAA;EAghCd;AALF;AAvgCQ;EACI,sBAAA;AA+gCZ;AA3gCY;EADJ;IAEQ,8BAAA;EA8gCd;EA1gCM;IAEQ,8BAAA;EA6gCd;AAJF;AArgCQ;EACI,kBAAA;AA4gCZ;AA1gCY;EACI,mBAAA;EACA,kBAAA;ED/BZ,mBAAA;ECiCY,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;AA4gChB;AA1gCgB;EATJ;ID7BR,kBAAA;ICwCgB,iBAAA;EA6gClB;AACF;AA3gCgB;EACI,gBAAA;AA6gCpB;AA1gCgB;EACI,gBAAA;AA4gCpB;AApgCgB;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAsgCpB;AApgCoB;EANJ;IAOQ,mBAAA;EAugCtB;AACF;AArgCoB;EACI,sBAAA;EACA,gBAAA;AAugCxB;AApgCoB;EACI,gBAAA;AAsgCxB;AAhgCgB;EACI,mBAAA;AAkgCpB;AAhgCoB;EAHJ;IAIQ,kBAAA;IACA,mBAAA;EAmgCtB;AACF;AA//BoB;EADJ;IAEQ,2BAAA;EAkgCtB;AACF;AA//BgB;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;AAigCpB;AA//BoB;EAPJ;IAQQ,SAAA;EAkgCtB;AACF;AAhgCoB;EACI,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAkgCxB;AAhgCwB;EANJ;IAOQ,SAAA;IACA,sBAAA;EAmgC1B;AACF;AAjgCwB;EACI,qDAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAmgC5B;AAjgC4B;EANJ;IAOQ,aAAA;EAogC9B;AACF;AAlgC4B;EACI,YAAA;EACA,WAAA;AAogChC;AAlgCgC;EAJJ;IAKQ,WAAA;EAqgClC;AACF;AAlgC4B;EACI,gBAAA;EACA,mBAAA;AAogChC;AAlgCgC;EAJJ;IAKQ,gBAAA;IACA,eAAA;IACA,iBAAA;EAqgClC;AACF;AAlgC4B;EACI,sBAAA;AAogChC;AAlgCgC;EAHJ;IAIQ,eAAA;IACA,iBAAA;EAqgClC;AACF;AA//BgB;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AAigCpB;AA//BoB;EARJ;IASQ,SAAA;EAkgCtB;AACF;AAhgCoB;EACI,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAkgCxB;AAhgCwB;EANJ;IAOQ,SAAA;IACA,sBAAA;EAmgC1B;AACF;AAjgCwB;EACI,qDAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAmgC5B;AAjgC4B;EANJ;IAOQ,aAAA;EAogC9B;AACF;AAlgC4B;EACI,YAAA;EACA,WAAA;AAogChC;AAlgCgC;EAJJ;IAKQ,WAAA;EAqgClC;AACF;AAlgC4B;EACI,gBAAA;EACA,mBAAA;AAogChC;AAlgCgC;EAJJ;IAKQ,gBAAA;IACA,eAAA;IACA,iBAAA;EAqgClC;AACF;AAlgC4B;EACI,sBAAA;AAogChC;AAlgCgC;EAHJ;IAIQ,eAAA;IACA,iBAAA;EAqgClC;AACF;AA9/BY;EACI,mBAAA;EACA,iBAAA;EACA,mBD/PL;AC+vCX;AA//BgB;EACI,0BAAA;EACA,mBAAA;AAigCpB;AA3/BQ;EACI,mBAAA;AA6/BZ;AA3/BY;EAHJ;IAIQ,8BAAA;EA8/Bd;AACF;AA5/BY;EACI,mBAAA;AA8/BhB;AA5/BgB;EACI,+CAAA;EACA,+BAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AA8/BpB;AA5/BoB;EATJ;IAUQ,iBAAA;EA+/BtB;AACF;AA7/BoB;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,OAAA;EACA,MAAA;AA+/BxB;AA3/BwB;EADJ;IAEQ,eAAA;IACA,iBAAA;EA8/B1B;AACF;AA3/BoB;EACI,eAAA;EACA,iBAAA;AA6/BxB;AA3/BwB;EAJJ;IAKQ,eAAA;IACA,iBAAA;EA8/B1B;AACF;AAt/BgB;EACI,eAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;AAw/BpB;AAr/BgB;EACI,eAAA;EACA,WAAA;EACA,YAAA;AAu/BpB;AAr/BoB;EACI,eAAA;EACA,WAAA;AAu/BxB;AAn/BgB;EACI,kCAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAq/BpB;AAn/BoB;EACI,aAAA;AAq/BxB;AA9+BY;EACI,mBAAA;AAg/BhB;AA7+BoB;EADJ;IAEQ,kBAAA;EAg/BtB;AACF;AA5+BY;EACI,mBAAA;AA8+BhB;AA5+BgB;EACI,aAAA;EACA,eAAA;EACA,SAAA;AA8+BpB;AA5+BoB;EALJ;IAMQ,SAAA;EA++BtB;AACF;AA7+BoB;EAEI,SAAA;EACA,mBAAA;EACA,aAAA;EACA,qDAAA;AA8+BxB;AA3+B4B;EACI,WAAA;AA6+BhC;AAz+BwB;EAbJ;IAcQ,WAAA;EA4+B1B;AACF;AA1+BwB;EAjBJ;IAkBQ,aAAA;IACA,gBAAA;EA6+B1B;AACF;AA3+BwB;EACI,eAAA;EACA,mBAAA;EACA,cDxZlB;ACq4CV;AA1+BwB;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AA4+B5B;AAz+BwB;EACI,sBAAA;AA2+B5B;AAz+B4B;EACI,gBAAA;EACA,cDvatB;ACk5CV;AAp+BY;EACI,mBAAA;AAs+BhB;AAp+BgB;EACI,aAAA;EACA,eAAA;EACA,SAAA;AAs+BpB;AAp+BoB;EALJ;IAMQ,SAAA;EAu+BtB;AACF;AAr+BoB;EAEI,SAAA;EACA,mBAAA;EACA,aAAA;EACA,6FAAA;AAs+BxB;AAn+B4B;EACI,WAAA;AAq+BhC;AAj+BwB;EAbJ;IAcQ,WAAA;EAo+B1B;AACF;AAl+BwB;EAjBJ;IAkBQ,aAAA;IACA,gBAAA;EAq+B1B;AACF;AAn+BwB;EACI,eAAA;EACA,mBAAA;AAq+B5B;AAj+BwB;EACI,gBAAA;EACA,mBAAA;EACA,cDzdlB;AC47CV;AAh+BwB;EACI,sBAAA;AAk+B5B;AAh+B4B;EACI,gBAAA;EACA,cDjetB;ACm8CV;AA39BY;;EAEI,mBAAA;AA69BhB;AA19BoB;EADJ;;IAEQ,kBAAA;EA89BtB;AACF;AAz9BgB;EACI,mBAAA;AA29BpB;AAz9BoB;EAHJ;IAIQ,kBAAA;IACA,mBAAA;EA49BtB;AACF;AAx9BoB;EADJ;IAEQ,2BAAA;EA29BtB;AACF;AAx9BgB;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;AA09BpB;AAx9BoB;EAPJ;IAQQ,SAAA;EA29BtB;AACF;AAz9BoB;EACI,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA29BxB;AAz9BwB;EANJ;IAOQ,SAAA;IACA,sBAAA;EA49B1B;AACF;AA19BwB;EACI,qDAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AA49B5B;AA19B4B;EANJ;IAOQ,aAAA;EA69B9B;AACF;AA39B4B;EACI,YAAA;EACA,WAAA;AA69BhC;AA39BgC;EAJJ;IAKQ,WAAA;EA89BlC;AACF;AA39B4B;EACI,gBAAA;EACA,mBAAA;AA69BhC;AA39BgC;EAJJ;IAKQ,gBAAA;IACA,eAAA;IACA,iBAAA;EA89BlC;AACF;AA39B4B;EACI,sBAAA;AA69BhC;AA39BgC;EAHJ;IAIQ,eAAA;IACA,iBAAA;EA89BlC;AACF;AAx9BgB;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AA09BpB;AAx9BoB;EARJ;IASQ,SAAA;EA29BtB;AACF;AAz9BoB;EACI,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA29BxB;AAz9BwB;EANJ;IAOQ,SAAA;IACA,sBAAA;EA49B1B;AACF;AA19BwB;EACI,qDAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AA49B5B;AA19B4B;EANJ;IAOQ,aAAA;EA69B9B;AACF;AA39B4B;EACI,YAAA;EACA,WAAA;AA69BhC;AA39BgC;EAJJ;IAKQ,WAAA;EA89BlC;AACF;AA39B4B;EACI,gBAAA;EACA,mBAAA;AA69BhC;AA39BgC;EAJJ;IAKQ,gBAAA;IACA,eAAA;IACA,iBAAA;EA89BlC;AACF;AA39B4B;EACI,sBAAA;AA69BhC;AA39BgC;EAHJ;IAIQ,eAAA;IACA,iBAAA;EA89BlC;AACF;AAv9BY;EACI,mBAAA;AAy9BhB;AAv9BgB;EACI,aAAA;EACA,eAAA;EACA,SAAA;AAy9BpB;AAv9BoB;EALJ;IAMQ,SAAA;EA09BtB;AACF;AAx9BoB;EACI,kCAAA;EAEA,mBAAA;EACA,aAAA;EACA,4CAAA;AAy9BxB;AAt9BwB;EARJ;IASQ,WAAA;EAy9B1B;AACF;AAv9BwB;EAZJ;IAaQ,aAAA;IACA,gBAAA;EA09B1B;AACF;AAx9BwB;EACI,eAAA;EACA,mBAAA;EACA,cDnqBpB;AC6nDR;AAv9BwB;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAy9B5B;AAt9BwB;EACI,sBAAA;AAw9B5B;AAt9B4B;EACI,gBAAA;EACA,cDprBtB;AC4oDV;AA/8BY;EACI,kBAAA;AAi9BhB;AA/8BgB;EACI,iBAAA;AAi9BpB;AA/8BoB;EACI,mBAAA;AAi9BxB;AA/8BwB;EACI,gBAAA;AAi9B5B;AA98BwB;EACI,kBAAA;EACA,gBAAA;AAg9B5B;AA98B4B;EACI,qBAAA;EACA,eAAA;AAg9BhC;AAv8BQ;EACI,kBAAA;AAy8BZ;AAv8BY;EACI,iBAAA;AAy8BhB;AAv8BgB;EACI,kBAAA;AAy8BpB;AAv8BoB;EACI,iBAAA;AAy8BxB;AAr8BgB;EACI,gBAAA;AAu8BpB;AAh8BgB;EACI,uCAAA;EACA,gBAAA;EACA,WAAA;AAk8BpB;AAj8BoB;EACI,UAAA;AAm8BxB;AA/7BgB;EACI;IACI,wBAAA;EAi8BtB;EA97BkB;IACI,0BAAA;EAg8BtB;EA77BkB;IACI,wBAAA;EA+7BtB;AACF","sourcesContent":["// Color Variables\n$primary: #1E2E5F;\n$secondary: #BE2532;\n$black: #000000;\n$white: #ffffff;\n$grey: #808080;\n$red: #D9132E;\n$lightbg: #fbfbfb;\n$lightblue:#E9F1FD;\n\n\n/*--------------Mixins------------------*/\n@mixin box-shadow($shadow) {\n    -webkit-box-shadow: $shadow;\n    -moz-box-shadow: $shadow;\n    box-shadow: $shadow;\n}\n\n@mixin border-radius($radius: none) {\n    -webkit-border-radius: $radius;\n    -moz-border-radius: $radius;\n    border-radius: $radius;\n}\n\n@mixin appearance() {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@function calculateRem($size) {\n    $remSize: $size / 16px;\n    @return #{$remSize}rem;\n}\n\n@mixin fontSize($size) {\n    //font-size: $size;\n    font-size: calculateRem($size);\n}\n\n@mixin position($position,\n    $top: null,\n    $right: null,\n    $bottom: null,\n    $left: null) {\n    position: $position;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n@mixin abs-position ($top, $right, $bottom, $left) {\n    // @include abs-position(10px, 10px, auto, auto);\n    position: absolute;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n// Margins\n@for $i from 0 to 20 {\n    .ml-#{$i} {\n        margin-left: 4px * $i !important;\n    }\n\n    .mr-#{$i} {\n        margin-right: 4px * $i !important;\n    }\n\n    .mt-#{$i} {\n        margin-top: 4px * $i !important;\n    }\n\n    .mb-#{$i} {\n        margin-bottom: 4px * $i !important;\n    }\n\n    .mx-#{$i} {\n        margin-left: 4px * $i !important;\n        margin-right: 4px * $i !important;\n    }\n\n    .my-#{$i} {\n        margin-top: 4px * $i !important;\n        margin-bottom: 4px * $i !important;\n    }\n}\n\n// Paddings\n@for $i from 0 to 20 {\n    .pl-#{$i} {\n        padding-left: 4px * $i !important;\n    }\n\n    .pr-#{$i} {\n        padding-right: 4px * $i !important;\n    }\n\n    .pt-#{$i} {\n        padding-top: 4px * $i !important;\n    }\n\n    .pb-#{$i} {\n        padding-bottom: 4px * $i !important;\n    }\n\n    .px-#{$i} {\n        padding-left: 4px * $i !important;\n        padding-right: 4px * $i !important;\n    }\n\n    .py-#{$i} {\n        padding-top: 4px * $i !important;\n        padding-bottom: 4px * $i !important;\n    }\n}","@import \"./Mixins.scss\";\n\n.productPages-layout {\n    padding-top: 156px;\n\n    @media(max-width:899px) {\n        padding-top: 85px;\n    }\n\n    .pp-inner {\n        padding-top: 80px;\n\n        @media(max-width:899px) {\n            padding-top: 30px;\n        }\n\n        h1 {\n            @media(max-width:899px) {\n                @include fontSize(32px);\n                line-height: 45px;\n            }\n        }\n\n        h2 {\n            @media(max-width:899px) {\n                @include fontSize(24px);\n                line-height: 36px;\n            }\n        }\n\n        h3 {\n            @include fontSize(24px);\n            line-height: 36px;\n\n            @media(max-width:899px) {\n                @include fontSize(24px);\n                line-height: 36px;\n            }\n        }\n\n        h4 {\n            @media(max-width:899px) {\n                @include fontSize(20px);\n                line-height: 30px;\n            }\n        }\n\n        p {\n            color: rgba(37, 37, 37, 1);\n        }\n\n        .mb-margin1 {\n            @media(max-width:899px) {\n                margin-bottom: 40px !important;\n            }\n        }\n\n        .mb-margin2 {\n            @media(max-width:899px) {\n                margin-bottom: 24px !important;\n            }\n        }\n\n        .ordered-list {\n            padding-left: 15px;\n\n            li {\n                margin-bottom: 12px;\n                position: relative;\n                @include fontSize(14px);\n                line-height: 25px;\n                color: rgba(34, 34, 34, 1);\n                text-align: justify;\n                list-style-type: decimal;\n\n                @media(max-width:899px) {\n                    @include fontSize(12px);\n                    line-height: 18px;\n                }\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n\n                span {\n                    font-weight: 500;\n                }\n            }\n        }\n\n        // main product pages\n        .main_pp {\n            ul {\n                li {\n                    font-size: 14px;\n                    line-height: 21px;\n                    margin-bottom: 8px;\n                    color: rgba(89, 89, 89, 1);\n\n                    @media(max-width:599px) {\n                        text-align: justify;\n                    }\n\n                    span {\n                        color: rgba(34, 34, 34, 1);\n                        font-weight: 600;\n                    }\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n\n            .whyChoose_pp_section {\n                h2 {\n                    margin-bottom: 56px;\n\n                    @media(max-width:899px) {\n                        text-align: center;\n                        margin-bottom: 24px;\n                    }\n                }\n\n                .wchoose_img {\n                    @media(max-width:599px) {\n                        max-width: 280px !important;\n                    }\n                }\n\n                .whyChoosepp_list {\n                    display: flex;\n                    flex-wrap: wrap;\n                    gap: 24px;\n                    align-items: center;\n                    flex-direction: row-reverse;\n\n                    @media(max-width:599px) {\n                        gap: 12px;\n                    }\n\n                    li {\n                        width: calc(50% - 12px);\n                        display: flex;\n                        flex-direction: column;\n                        gap: 24px;\n\n                        @media(max-width:599px) {\n                            gap: 12px;\n                            width: calc(50% - 6px);\n                        }\n\n                        .wc_box {\n                            box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.12);\n                            border-radius: 12px;\n                            padding: 24px;\n                            text-align: center;\n\n                            @media(max-width:599px) {\n                                padding: 12px;\n                            }\n\n                            img {\n                                margin: auto;\n                                width: 90px;\n\n                                @media(max-width:599px) {\n                                    width: 60px;\n                                }\n                            }\n\n                            h6 {\n                                margin-top: 24px;\n                                margin-bottom: 12px;\n\n                                @media(max-width:599px) {\n                                    margin-top: 12px;\n                                    font-size: 14px;\n                                    line-height: 21px;\n                                }\n                            }\n\n                            p {\n                                color: rgba(89, 89, 89, 1);\n\n                                @media(max-width:599px) {\n                                    font-size: 12px;\n                                    line-height: 18px;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                .whyChoosepp_list2 {\n                    display: flex;\n                    flex-wrap: wrap;\n                    gap: 24px;\n                    align-items: center;\n                    justify-content: center;\n                    flex-direction: row-reverse;\n\n                    @media(max-width:599px) {\n                        gap: 12px;\n                    }\n\n                    li {\n                        width: calc(50% - 12px);\n                        display: flex;\n                        flex-direction: column;\n                        gap: 24px;\n\n                        @media(max-width:599px) {\n                            gap: 12px;\n                            width: calc(50% - 6px);\n                        }\n\n                        .wc_box {\n                            box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.12);\n                            border-radius: 12px;\n                            padding: 24px;\n                            text-align: center;\n\n                            @media(max-width:599px) {\n                                padding: 12px;\n                            }\n\n                            img {\n                                margin: auto;\n                                width: 90px;\n\n                                @media(max-width:599px) {\n                                    width: 60px;\n                                }\n                            }\n\n                            h6 {\n                                margin-top: 24px;\n                                margin-bottom: 12px;\n\n                                @media(max-width:599px) {\n                                    margin-top: 12px;\n                                    font-size: 14px;\n                                    line-height: 21px;\n                                }\n                            }\n\n                            p {\n                                color: rgba(89, 89, 89, 1);\n\n                                @media(max-width:599px) {\n                                    font-size: 12px;\n                                    line-height: 18px;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n\n            .formBox {\n                border-radius: 12px;\n                padding: 20px 8px;\n                background: $lightblue;\n                .checkbox .MuiTypography-root {\n                    font-size: 12px !important;\n                    text-align: justify;\n                }\n            }\n        }\n\n        // sub product pages\n        .subProducts_pp {\n            margin-bottom: 80px;\n\n            @media(max-width:899px) {\n                margin-bottom: 40px !important;\n            }\n\n            .points-slider {\n                margin-bottom: 12px;\n\n                .pointBox {\n                    box-shadow: 0 4px 14px 0 rgba(30, 46, 95, 0.06);\n                    border-radius: 50px 0 20px 20px;\n                    padding: 24px;\n                    position: relative;\n                    min-height: 252px;\n                    margin-bottom: 12px;\n                    text-align: left;\n\n                    @media(max-width:599px) {\n                        min-height: 200px;\n                    }\n\n                    &:before {\n                        content: \"\";\n                        position: absolute;\n                        width: 80px;\n                        height: 80px;\n                        border-radius: 50px 0 0 0;\n                        border-top: 1px solid $primary;\n                        border-left: 1px solid $primary;\n                        left: 0;\n                        top: 0;\n                    }\n\n                    h4 {\n                        @media(max-width:599px) {\n                            font-size: 20px;\n                            line-height: 30px;\n                        }\n                    }\n\n                    p {\n                        font-size: 16px;\n                        line-height: 24px;\n\n                        @media(max-width:599px) {\n                            font-size: 14px;\n                            line-height: 21px;\n                        }\n                    }\n                }\n\n\n            }\n\n            .slick-slider {\n                .slick-active button {\n                    min-width: 32px;\n                    outline: 1px solid $primary;\n                    outline-offset: -1px;\n                    background: transparent;\n                }\n\n                .slick-dots li {\n                    margin: 0px 4px;\n                    width: 12px;\n                    height: 12px;\n\n                    &.slick-active {\n                        min-width: 32px;\n                        width: 32px;\n                    }\n                }\n\n                li button {\n                    background: rgba(36, 72, 140, 0.4);\n                    border-radius: 50px !important;\n                    border: none;\n                    width: 12px;\n                    height: 12px;\n\n                    &::before {\n                        display: none;\n                    }\n                }\n\n            }\n\n\n            .coverages-section {\n                margin-bottom: 80px;\n\n                h2 {\n                    @media(max-width:899px) {\n                        text-align: center;\n                    }\n                }\n            }\n\n            .claimProcedure-section {\n                margin-bottom: 80px;\n\n                .claimProcedure_list {\n                    display: flex;\n                    flex-wrap: wrap;\n                    gap: 24px;\n\n                    @media(max-width:699px) {\n                        gap: 16px;\n                    }\n\n                    li {\n                        // width: calc(50% - 12px);\n                        flex: 1;\n                        border-radius: 12px;\n                        padding: 24px;\n                        box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.12);\n\n                        &:nth-child(odd) {\n                            &:last-child {\n                                width: 100%;\n                            }\n                        }\n\n                        @media(max-width:699px) {\n                            width: 100%;\n                        }\n\n                        @media(max-width:499px) {\n                            padding: 16px;\n                            min-width: 240px;\n                        }\n\n                        h4 {\n                            font-size: 20px;\n                            margin-bottom: 12px;\n                            color: $primary;\n                        }\n\n                        h6 {\n                            font-weight: 600;\n                            display: flex;\n                            align-items: center;\n                            gap: 12px;\n                        }\n\n                        p {\n                            color: rgba(89, 89, 89, 1);\n\n                            a {\n                                font-weight: 600;\n                                color: $primary;\n                            }\n                        }\n                    }\n                }\n            }\n\n            .alopTop-section {\n                margin-bottom: 80px;\n\n                .alop_list {\n                    display: flex;\n                    flex-wrap: wrap;\n                    gap: 24px;\n\n                    @media(max-width:699px) {\n                        gap: 16px;\n                    }\n\n                    li {\n                        // width: calc(50% - 12px);\n                        flex: 1;\n                        border-radius: 12px;\n                        padding: 24px;\n                        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(91, 132, 188, 0.05) 100%);\n\n                        &:nth-child(odd) {\n                            &:last-child {\n                                width: 100%;\n                            }\n                        }\n\n                        @media(max-width:699px) {\n                            width: 100%;\n                        }\n\n                        @media(max-width:499px) {\n                            padding: 16px;\n                            min-width: 240px;\n                        }\n\n                        h4 {\n                            font-size: 20px;\n                            margin-bottom: 12px;\n\n                        }\n\n                        h6 {\n                            font-weight: 600;\n                            margin-bottom: 20px;\n                            color: $primary;\n                        }\n\n                        p {\n                            color: rgba(89, 89, 89, 1);\n\n                            a {\n                                font-weight: 600;\n                                color: $primary;\n                            }\n                        }\n                    }\n                }\n            }\n\n            .termsConditions_section,\n            .excluison_section {\n                margin-bottom: 80px;\n\n                h2 {\n                    @media(max-width:899px) {\n                        text-align: center;\n                    }\n                }\n            }\n\n            .whyChoose_pp_section {\n                h2 {\n                    margin-bottom: 56px;\n\n                    @media(max-width:899px) {\n                        text-align: center;\n                        margin-bottom: 24px;\n                    }\n                }\n\n                .wchoose_img {\n                    @media(max-width:599px) {\n                        max-width: 280px !important;\n                    }\n                }\n\n                .whyChoosepp_list {\n                    display: flex;\n                    flex-wrap: wrap;\n                    gap: 24px;\n                    align-items: center;\n                    flex-direction: row-reverse;\n\n                    @media(max-width:599px) {\n                        gap: 12px;\n                    }\n\n                    li {\n                        width: calc(50% - 12px);\n                        display: flex;\n                        flex-direction: column;\n                        gap: 24px;\n\n                        @media(max-width:599px) {\n                            gap: 12px;\n                            width: calc(50% - 6px);\n                        }\n\n                        .wc_box {\n                            box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.12);\n                            border-radius: 12px;\n                            padding: 24px;\n                            text-align: center;\n\n                            @media(max-width:599px) {\n                                padding: 12px;\n                            }\n\n                            img {\n                                margin: auto;\n                                width: 90px;\n\n                                @media(max-width:599px) {\n                                    width: 60px;\n                                }\n                            }\n\n                            h6 {\n                                margin-top: 24px;\n                                margin-bottom: 12px;\n\n                                @media(max-width:599px) {\n                                    margin-top: 12px;\n                                    font-size: 14px;\n                                    line-height: 21px;\n                                }\n                            }\n\n                            p {\n                                color: rgba(89, 89, 89, 1);\n\n                                @media(max-width:599px) {\n                                    font-size: 12px;\n                                    line-height: 18px;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                .whyChoosepp_list2 {\n                    display: flex;\n                    flex-wrap: wrap;\n                    gap: 24px;\n                    align-items: center;\n                    justify-content: center;\n                    flex-direction: row-reverse;\n\n                    @media(max-width:599px) {\n                        gap: 12px;\n                    }\n\n                    li {\n                        width: calc(50% - 12px);\n                        display: flex;\n                        flex-direction: column;\n                        gap: 24px;\n\n                        @media(max-width:599px) {\n                            gap: 12px;\n                            width: calc(50% - 6px);\n                        }\n\n                        .wc_box {\n                            box-shadow: -12px 12px 40px 0 rgba(32, 56, 100, 0.12);\n                            border-radius: 12px;\n                            padding: 24px;\n                            text-align: center;\n\n                            @media(max-width:599px) {\n                                padding: 12px;\n                            }\n\n                            img {\n                                margin: auto;\n                                width: 90px;\n\n                                @media(max-width:599px) {\n                                    width: 60px;\n                                }\n                            }\n\n                            h6 {\n                                margin-top: 24px;\n                                margin-bottom: 12px;\n\n                                @media(max-width:599px) {\n                                    margin-top: 12px;\n                                    font-size: 14px;\n                                    line-height: 21px;\n                                }\n                            }\n\n                            p {\n                                color: rgba(89, 89, 89, 1);\n\n                                @media(max-width:599px) {\n                                    font-size: 12px;\n                                    line-height: 18px;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n\n            .errors-ommission-section {\n                margin-bottom: 80px;\n\n                .omissionPointList {\n                    display: flex;\n                    flex-wrap: wrap;\n                    gap: 24px;\n\n                    @media(max-width:699px) {\n                        gap: 16px;\n                    }\n\n                    li {\n                        width: calc((100% / 3) - 16px);\n                        // flex: 1;\n                        border-radius: 24px;\n                        padding: 24px;\n                        background: #1E71EC1A;\n\n\n                        @media(max-width:699px) {\n                            width: 100%;\n                        }\n\n                        @media(max-width:499px) {\n                            padding: 16px;\n                            min-width: 240px;\n                        }\n\n                        h4 {\n                            font-size: 20px;\n                            margin-bottom: 12px;\n                            color: $black;\n                        }\n\n                        h6 {\n                            font-weight: 600;\n                            display: flex;\n                            align-items: center;\n                            gap: 12px;\n                        }\n\n                        p {\n                            color: rgba(89, 89, 89, 1);\n\n                            a {\n                                font-weight: 600;\n                                color: $primary;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        .scroll-box-section {\n            .scrollBox {\n                overflow-y: scroll;\n\n                .scrollBox-inner {\n                    max-height: 200px;\n\n                    ul li {\n                        margin-bottom: 12px;\n\n                        &:last-child {\n                            margin-bottom: 0;\n                        }\n\n                        .dottted-list {\n                            padding-left: 30px;\n                            margin-top: 12px;\n\n                            li {\n                                list-style-type: disc;\n                                font-size: 13px\n                            }\n                        }\n                    }\n\n                }\n            }\n        }\n\n        .exclusion_list {\n            overflow-y: scroll;\n\n            .ordered-list {\n                max-height: 200px;\n\n                .exclusion_list {\n                    overflow-y: scroll;\n\n                    .ordered-list {\n                        max-height: 200px;\n                    }\n                }\n\n                .ordered-inner-list li {\n                    list-style: none;\n                }\n            }\n        }\n\n        .animatedbtn {\n            button {\n                svg {\n                    animation: arrowmove 1s infinite linear;\n                    margin-left: 4px;\n                    width: 20px;\n                    path{\n                        fill:#fff;\n                    }\n                }\n\n                @keyframes arrowmove {\n                    0% {\n                        transform: translateX(0);\n                    }\n\n                    50% {\n                        transform: translateX(4px);\n                    }\n\n                    100% {\n                        transform: translateX(0);\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
